export class ImageMetadata {
  public title: string;
  public shortDescription: string;
  public description: string;
  public copyright: string;
  public photoTakenDate: Date | null;
  public location: string;
  public order: number;

  constructor(data: any = {}) {
    this.title = data?.title ?? '';
    this.shortDescription = data?.shortDescription ?? '';
    this.description = data?.description ?? '';
    this.copyright = data?.copyright ?? '';
    this.photoTakenDate = data?.photoTakenDate ? new Date(data?.photoTakenDate) : null;
    this.location = data?.location ?? '';
    this.order = data?.order ?? data?.index ?? 0;
  }

  public static createFromApi(data: any = {}): ImageMetadata {
    return new ImageMetadata(data);
  }

  public processForApi(): Record<string, any> {
    return {
      ...this,
      photoTakenDate: this.photoTakenDate instanceof Date ? this.photoTakenDate.toJSON() : null,
    };
  }
}
